import { ADMIN } from "../constants/rolesName";
import { TOKEN_KEY } from "../constants/storageKey";

export function decodeJWT(token) {
  if (!token) return null;
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function checkAdmin() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return false;
  const decodedToken = decodeJWT(token);

  return decodedToken.roles && decodedToken.roles.includes(ADMIN);
}
